<template>
    <MainContainer>
        <div class="col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 tc">

            <img style="width:100px;" class="mt5 mb3" src="@/assets/img/icon_check.svg"/>
            <h3 class="mb3" >Thank you, your payment is complete.</h3>
            <h5>The owner has been contacted and will confirm your next rental.</h5>
            <div class="bodyCopy mt3">A confirmation email will be sent to you once the rental is confirmed. Your payment will only be processed after the owner has confirmed the rental.</div>
            <h6 class="mt3 mb3">Rental ID: 09840923456</h6>

            <div class="w-100 mb5">
                <TooliabaButton>View Invoice</TooliabaButton>
            </div>

        </div>
    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    components: {
        MainContainer,
        TooliabaButton
    }
};
</script>
